import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { I18nProvider, isLocale, loadCatalog } from './utils/i18n.tsx'
import { voorHydratie } from './utils/voor-hydratie.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

// <html lang> is the SSR truth for the active locale; its catalog chunk must
// be in memory before hydration or the client tree wouldn't match the server's.
const lang = document.documentElement.lang
const locale = isLocale(lang) ? lang : 'nl'

// and what the routes on the page asked to have in memory first (a lazy
// tray that is already open, voor-hydratie.ts)
void Promise.all([loadCatalog(locale), voorHydratie()]).then(([messages]) => {
	startTransition(() => {
		hydrateRoot(
			document,
			<I18nProvider locale={locale} messages={messages}>
				<HydratedRouter />
			</I18nProvider>,
		)
	})
})
